import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ProblemWorkspace } from '@/features/ProblemWorkspace/ProblemWorkspace';

// batchId/topicId carry where the student came from. They are what "next
// problem" resolves against (see useProblemSequence) — batchId used to be
// validated and then dropped on the floor here, which is why prev/next could
// only ever walk the global catalogue.
const searchSchema = z.object({
  batchId: z.string().optional(),
  topicId: z.string().optional(),
  hackathonComponentId: z.string().optional(),
});

export const Route = createFileRoute('/_student/problems/$slug')({
  validateSearch: searchSchema,
  component: ProblemPage,
});

function ProblemPage() {
  const { slug } = Route.useParams();
  const { topicId, batchId, hackathonComponentId } = Route.useSearch();
  return (
    <div className="h-screen">
      <ProblemWorkspace
        slug={slug}
        topicId={topicId}
        batchId={batchId}
        hackathonComponentId={hackathonComponentId}
      />
    </div>
  );
}
